<template>
	<div class="fluid self_reported_courses w-100">
    <div class="courses_section" v-if="isCoursesLoaded">
      <template v-if="((Object.keys(selfReportedCourseMap).length > 0) && !$parent.isGuestLogin)">
        <div class="inst_list_container">
          <template v-for="(courses, label, i) in selfReportedCourseMap">
            <div v-if="courses.length > 0">
              <div class="row" role="heading" tabindex="0" style="background: #969696;">
                <div class="col-12" style="height: 30px;">
                  <div class="title-txt">{{label}}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <b-collapse visible :id="'institution-' + i">
                    <div class="course_list_container">
                      <span v-for="course in courses" :key="course.originUuid">
                        <div class="row course_row">
                          <div class="title col-6">
                            <div>
                              <div class="float-left text-center mr-3" style="width: 80px;">
                                <div style="height: 50px; border-radius: 8px;" :style="{background: setThumbnailBgColor(course.uuid)}">
                                  <div style="line-height: 50px; color: #fff;">
                                    <div v-html="setThumbnailTitle(course)"></div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div class="col_title" style="cursor: default !important; color: #5f5f5f !important;">
                                  {{course.title}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-2">
                            <div class="txt_container">
                              <span>
                                {{course.creditsEarned}} credits
                              </span>
                            </div>
                          </div>
                          <template v-if="(course.entityType === 'deliverycontext')">
	                          <div class="col-4">
	                            <course-progress-bar :course-id="course.originUuid" @launchCourse="launchCourse"></course-progress-bar>
	                          </div>
                          </template>
                          <template v-if="(course.entityType === 'catalog')">
	                          <div class="col-4 text-center">
	                            <div class="float-left">
                                <b-button :class="courseStatusBackgroundMap[course.courseStatus]" style="width: 170px;" @click="openStatusDropDown(course)">
                                  <div style="color: #fff;">{{courseStatusMap[course.courseStatus]}}</div>
                                </b-button>
                              </div>
                              <div class="float-right">
                                <span class="icon-pencil" :id="'courseStatusSetting-' + course.originUuid" style="cursor: pointer;" @click="openStatusDropDown(course)"></span>
                                <div :id="'courseStatusPopup-' + course.originUuid"></div>
	                            </div>
	                          </div>
	                        </template>
                        </div>
                      </span>
                    </div>
                  </b-collapse>
                </div>
              </div>

            </div>
          </template>
        </div>
      </template>
    </div>

    <template v-if="clickedCourse">
      <b-popover ref="courseStatusPopover" :target="'courseStatusSetting-' + clickedCourse.originUuid" triggers="click" :container="'courseStatusPopup-' + clickedCourse.originUuid" placement="left">
        <div>
          <b-form-group>
            <b-form-radio-group plain stacked v-model="selectedStatus">
              <template v-for="status in [0, 1, 2, 7]">
                <b-form-radio class="mt-3" :value="status" @change="closeStatusDropDown(true, status)">
                  <b-button :class="courseStatusBackgroundMap[status]" style="width: 170px;" @click="closeStatusDropDown(true, status)">
                    <div style="color: #fff;">{{courseStatusMap[status]}}</div>
                  </b-button>
                </b-form-radio>
              </template>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </b-popover>
    </template>

  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'
  import CourseProgressBar from './CourseProgressBar'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-course-progress',
    props: ['pathwayId'],
    components: {
      CourseProgressBar
    },
    data () {
      return {
        selfReportedCourseMap: {},
        userId: localStore.getItem('userid'),
        username: localStore.getItem('userFullName'),
        isCoursesLoaded: false,
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        }
      }
    },
    mounted () {
      this.showLoader()
      this.loadCourseList()
    },
    methods: {
      ...mapActions([
        'loadProgramCourseList',
        'updateProgramCourseStatus',
        'navigateUserToCourseDashboard'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      async updateCourseStatus (streamId, status) {
    		let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
        	this.resetPage()
        })
      },
      async loadCourseList () {
        this.loadProgramCourseList(this.pathwayId).then(result => {
          this.selfReportedCourseMap = _.groupBy(result, 'parentId')
          this.totalElements = result.length
          this.hideLoader()
          this.selected = [],
          this.isCoursesLoaded = true
        })
      },
      resetPage () {
        this.loadCourseList()
      },
      openStatusDropDown (course) {
        this.selectedStatus = course.courseStatus
        if (this.clickedCourse) {
          this.closeStatusDropDown(false)
        } else {
          this.clickedCourse = course
          setTimeout(() => {
            this.$refs.courseStatusPopover.$emit('open')
          }, 250)
        }        
      },
      closeStatusDropDown (toBeUpdated, status) {
        if (toBeUpdated) {
          this.updateCourseStatus(this.clickedCourse.uuid, status)
        }
        this.clickedCourse = ''
        this.selectedStatus = ''
        this.$refs.courseStatusPopover.$emit('close')
      },
      launchCourse (courseId) {
        let token = localStore.getItem('token')
        this.navigateUserToCourseDashboard({courseId: courseId, token: token}).then(href => {
          window.open(href, '_blank')
        })
      }
    }
  }
</script>

<style>
  .title-txt {
    color: #fff;
    margin-top: 3px;
    font-weight: 500;
    text-align: center;
  }

  div[id^="courseStatusPopup-"] .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 220px !important;
    width: 220px !important;
    height: 225px !important;    
    margin-top: 15px;
  }

  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;    
  }

  .form-check-input {
    top: 12px;
    cursor: pointer;
  }  

  .status-not-started {
    background: #b4b4b4 !important;
  }

  .status-in-progress {
    background: #dd9623 !important;
  }

  .status-completed {
    background: #0a7714 !important;
  }

  .status-not-completed {
    background: #f40909 !important;
  }
</style>


// WEBPACK FOOTER //
// src/app/transfer/components/ProgramCourseProgress.vue